import * as React from 'react';
import { Button } from 'react-bootstrap';
import { IReport } from '../../../common/sharedTypes';
import * as documentDownloadService from '../../../services/documentDownloadService';

export interface IDriverPdfsButtonProps {
  report: IReport;
}

export default class DriverPdfsButton extends React.Component<IDriverPdfsButtonProps> {
  handleOpenDriverPdfs = () => {
    if (
      this.props.report.reportsMergedToThis &&
      this.props.report.reportsMergedToThis.length > 0 &&
      this.props.report.reportsMergedToThis.filter(
        (x) => x.keywords.reportTypeId == 2
      ).length > 0
    ) {
      const mergedDriverReports = this.props.report.reportsMergedToThis.filter(
        (x) => x.keywords.reportTypeId == 2
      );
      mergedDriverReports.forEach((x) => {
        documentDownloadService.openOnBaseImage(
          x.crashReportId,
          x.keywords.documentId
        );
      });
    }
  };

  public render() {
    return (
      <React.Fragment>
        {this.props.report.reportsMergedToThis &&
          this.props.report.reportsMergedToThis.length > 0 &&
          this.props.report.reportsMergedToThis.filter(
            (x) => x.keywords.reportTypeId == 2
          ).length > 0 && (
            <Button
              variant='secondary'
              size='sm'
              onClick={() => this.handleOpenDriverPdfs()}
              className='openReportPdfButton'
            >
              Open Driver PDFs
            </Button>
          )}
      </React.Fragment>
    );
  }
}
